export const routes = Object.freeze({
  root: '/time-management',
  timeEntryDetail: '/time-management/time-card/:id',
  timeEntryDetailEdit: '/time-management/time-card/:id/edit',
});

export const paths = Object.values(routes);
